export const INSTANT_SEARCH_INDEX_NAME = 'category';
export const INSTANT_SEARCH_QUERY_SUGGESTIONS =
  'category_query_suggestions';
export const INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES = [
  'hierarchicalCategories.lvl0',
  'hierarchicalCategories.lvl1',
];
